module.exports = __webpack_public_path__ + "img/logo.f74e1fc3.png";